import { useContext, useMemo } from "react";
import { useFinancialDocumentsQuery } from "../documents/useFinancialDocumentsQuery";
import { useWorkspaceContext } from "../../state/workspaceContext";
import { ImporterContext } from "./importer.context";
import { documentBeingProcessed } from "./helpers";

export function useImporterDocumentsRefresh() {
    const { documentRows, updateDocumentRow } = useContext(ImporterContext);
    const { activeWorkspaceId } = useWorkspaceContext();
    const documentsRequiringRefresh = useMemo(
        () =>
            documentRows
                .map((row) => row.financialDocument)
                .filter((document) => document !== undefined)
                .filter(documentBeingProcessed),
        [documentRows],
    );

    useFinancialDocumentsQuery({
        queryParams: {
            workspace: activeWorkspaceId ?? "",
            filters: {
                financialDocumentIds: documentsRequiringRefresh.map(
                    (document) => document.id,
                ),
            },
            limit: 0,
            page: 0,
        },
        shouldRefetch: () => documentsRequiringRefresh.length > 0,
        onSuccess: ({ data: refreshedDocuments }) => {
            refreshedDocuments.forEach((document) => {
                const documentRow = documentRows.find(
                    (row) => row.financialDocument?.id === document.id,
                );
                if (documentRow && document.integrationAccount) {
                    updateDocumentRow(documentRow.id, {
                        financialDocument: document,
                        integrationAccount: document.integrationAccount,
                    });
                }
            });
        },
        additionalParams: {
            enabled: documentsRequiringRefresh.length > 0,
        },
    });
}
